
import { useEffect, useState } from 'react';

export default function PricingHero() {
  const [animated, setAnimated] = useState(false);
  const [currentBg, setCurrentBg] = useState(0);

  useEffect(() => {
    setAnimated(true);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBg((prev) => (prev + 1) % 4);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const backgrounds = [
    '/images/pricing-bg-1.jpg',
    '/images/pricing-bg-2.jpg',
    '/images/pricing-bg-3.jpg',
    '/images/pricing-bg-4.jpg'
  ];

  return (
    <section className="relative min-h-[70vh] flex items-center overflow-hidden bg-[#1a1a1a]">
      {backgrounds.map((bg, index) => (
        <div
          key={index}
          className="absolute inset-0 transition-opacity duration-2000"
          style={{
            opacity: currentBg === index ? 0.5 : 0,
            backgroundImage: `url(${bg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        />
      ))}

      <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-black/5"></div>

      <div className="relative z-10 w-full">
        <div className="max-w-[1200px] mx-auto px-6 sm:px-8 py-16 sm:py-24 lg:py-32">
          <div className="max-w-[900px] mx-auto text-center space-y-4 sm:space-y-6 lg:space-y-8">
            <h1
              className={`font-harvey-serif text-white text-[36px] sm:text-[48px] lg:text-[68px] font-normal leading-[1.05] tracking-tight transition-all duration-700 ${
                animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
              }`}
            >
              Founder Pricing
            </h1>

            <p
              className={`font-harvey-sans text-white/90 text-[18px] sm:text-[20px] lg:text-[24px] leading-relaxed font-light tracking-wide transition-all duration-700 delay-200 ${
                animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              The legal AI lawyers have been waiting for. Private. Mobile. Affordable
            </p>

            <div
              className={`space-y-3 sm:space-y-4 transition-all duration-700 delay-400 ${
                animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              <p className="font-harvey-sans text-white text-[16px] sm:text-[18px] lg:text-[20px] font-medium tracking-wide">
                Attorneys across Michigan are claiming early access every day
              </p>
              <p className="font-harvey-sans text-[#d4af37] text-[16px] sm:text-[18px] lg:text-[20px] font-semibold tracking-wide">
                Lock in the lowest price we'll ever offer. Keep it forever
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
